import React, { Component } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { fetchUserToken, fetchShoppingCartItems } from "../../redux/actions";
import _ from "lodash";

import OrderListItem from "./orderListItem";
import DecisionButtons from "./decisionButtons";

class OrderListPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      show: true
    };
  }

  componentDidMount() {
    if (_.isEmpty(this.props.userToken)) {
      this.props.fetchUserToken().then(() => {
        this.props.fetchShoppingCartItems(this.props.userToken);
      });
    } else {
      this.props.fetchShoppingCartItems(this.props.userToken);
    }

    this.setState({
      loading: false
    });
  }

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  handleShow = () => {
    this.setState({
      show: true
    });
  };

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }

    let customDiv = null;

    let shoppingCartItems = this.props.shoppingCartItems;
    let orderedList = [];
    let col = [];
    if (!_.isEmpty(shoppingCartItems)) {
      if (!shoppingCartItems.includes("empty")) {

        console.log("JSON contact "+localStorage.getItem("orderListContactDetail"));

        let orderListContactDetail = JSON.parse(
          localStorage.getItem("orderListContactDetail")
        );

        let isReciept = orderListContactDetail.isReciept !=null ?orderListContactDetail.isReciept : false;

        //let contactfirstName = "Tester"
       let contactfirstName =
          orderListContactDetail.contactfirstName != null
            ? orderListContactDetail.contactfirstName
        : "";
        let contactlastName =
          orderListContactDetail.contactlastName != null
            ? orderListContactDetail.contactlastName
            : "";

        let contactDisplayName = orderListContactDetail.contactDisplayName || '';
        let contactPersonEmailAddress =
          orderListContactDetail.contactPersonEmailAddress != null
            ? orderListContactDetail.contactPersonEmailAddress
            : "";
        let contactPersonPhone =
          orderListContactDetail.contactPersonPhone != null
            ? orderListContactDetail.contactPersonPhone
            : "";

        for (let i = 0; i < shoppingCartItems.length; i++) {
          let orderedObject = shoppingCartItems[i].order;
          let orderedColor = Object.keys(orderedObject)[0];
          let orderedNum = orderedObject[orderedColor];
          let shoppingCartItemsUnitPrice = shoppingCartItems[i].totalPrice;
          let totalPrice = shoppingCartItemsUnitPrice * orderedNum;

          orderedList.push(
            <OrderListItem
              key={i}
              name={shoppingCartItems[i].product.name}
              orderNum={orderedNum}
              price={totalPrice}
              imgURL={shoppingCartItems[i].product.imageURL}
            />
          );

          if (orderListContactDetail.recipientfirstName == null) {
            // send email to different address

            let rec =
            orderListContactDetail["recipient" + (i + 1) + "firstName"] !=
            null
              ? orderListContactDetail["recipient" + (i + 1) + "firstName"]
              : "";

            let recipientfirstName =
              orderListContactDetail["recipient" + (i + 1) + "firstName"] !=
              null
                ? orderListContactDetail["recipient" + (i + 1) + "firstName"]
                : "";
            let recipientlastName =
              orderListContactDetail["recipient" + (i + 1) + "lastName"] != null
                ? orderListContactDetail["recipient" + (i + 1) + "lastName"]
                : "";

            const recipientDisplayName = orderListContactDetail["recipient" + (i + 1) + "DisplayName"] || '';
            let recipientPhone =
              orderListContactDetail["recipientPhone" + (i + 1)] != null
                ? orderListContactDetail["recipientPhone" + (i + 1)]
                : "";
            let deliveryAddress =
              orderListContactDetail["deliveryAddress" + (i + 1)] != null
                ? orderListContactDetail["deliveryAddress" + (i + 1)]
                : "";
            let deliveryDate =
              orderListContactDetail["deliveryDate" + (i + 1)] != null
                ? orderListContactDetail["deliveryDate" + (i + 1)]
                : "";
            let deliveryTime =
              orderListContactDetail["deliveryTime" + (i + 1)] != null
                ? orderListContactDetail["deliveryTime" + (i + 1)]
                : "";
            let region = orderListContactDetail["subRegionValue" + (i + 1)] != null
                ? orderListContactDetail["subRegionValue" + (i + 1)]
                : "";
            let messageTo =
              orderListContactDetail["messageTo" + (i + 1)] != null
                ? orderListContactDetail["messageTo" + (i + 1)]
                : "";
            let messageContent =
              orderListContactDetail["messageContent" + (i + 1)] != null
                ? orderListContactDetail["messageContent" + (i + 1)]
                : "";
            let messageFrom =
              orderListContactDetail["messageFrom" + (i + 1)] != null
                ? orderListContactDetail["messageFrom" + (i + 1)]
                : "";
            let orderNotes =
              orderListContactDetail["orderNotes" + (i + 1)] != null
                ? orderListContactDetail["orderNotes" + (i + 1)]
                : "";

            col.push(
              <Col md={6} mdPush={6} className="orderListPanelCol" key={i}>
                <h4>
                  <b>Item {i + 1}</b>
                </h4>
                <br />
                <div>
                  <b>Recipient Details</b>
                </div>
                <br />
                <div>Display name: {recipientDisplayName}</div>
                <br />
                {/*<div>Last name: {recipientlastName}</div>*/}
                {/*<br />*/}
                <div>Phone: {recipientPhone}</div>
                <hr />
                <div>
                  <b>Delivery Details</b>
                </div>
                <br />
                <div>Delivery date: {deliveryDate}</div>
                <br />
                <div>Delivery time: {deliveryTime}</div>
                <br />
                <div>Delivery Address: {deliveryAddress}</div>
                <br />
                <div>Region: {region}</div>
                <hr />
                <div>
                  <b>Message Details</b>
                </div>
                <br />
                {/*<div>To: {messageTo}</div>*/}
                {/*<br />*/}
                <div>Message: {messageContent}</div>
                {/*<div>From: {messageFrom}</div>*/}
                <hr />
                <div>
                  <b>Order Notes to us</b>
                </div>
                <br />
                <div>{orderNotes}</div>
              </Col>
            );
          } else {
            // send email to same address
            let recipientfirstName =
              orderListContactDetail.recipientfirstName != null
                ? orderListContactDetail.recipientfirstName
                : "";
            let recipientlastName =
              orderListContactDetail.recipientlastName != null
                ? orderListContactDetail.recipientlastName
                : "";
            let recipientPhone =
              orderListContactDetail.recipientPhone != null
                ? orderListContactDetail.recipientPhone
                : "";
            let deliveryAddress =
              orderListContactDetail.deliveryAddress != null
                ? orderListContactDetail.deliveryAddress
                : "";
            let deliveryDate =
              orderListContactDetail.deliveryDate != null
                ? orderListContactDetail.deliveryDate
                : "";
            let deliveryTime =
              orderListContactDetail.deliveryTime != null
                ? orderListContactDetail.deliveryTime
                : "";
            let region =
              orderListContactDetail.regionValue != null &&
              orderListContactDetail.subRegionValue != null
                ? orderListContactDetail.regionValue +
                  ", " +
                  orderListContactDetail.subRegionValue
                : "";
            let messageTo =
              orderListContactDetail.messageTo != null
                ? orderListContactDetail.messageTo
                : "";
            let messageContent =
              orderListContactDetail.messageContent != null
                ? orderListContactDetail.messageContent
                : "";
            let messageFrom =
              orderListContactDetail.messageFrom != null
                ? orderListContactDetail.messageFrom
                : "";
            let orderNotes =
              orderListContactDetail.orderNotes != null
                ? orderListContactDetail.orderNotes
                : "";

            col.push(
              <Col md={6} mdPush={6} className="orderListPanelCol" key={i}>
                <h4>
                  <b>Item {i + 1}</b>
                </h4>
                <br />
                <div>
                  <b>Recipient Details</b>
                </div>
                <br />
                <div>First name: {recipientfirstName}</div>
                <br />
                <div>Last name: {recipientlastName}</div>
                <br />
                <div>Phone: {recipientPhone}</div>
                <hr />
                <div>
                  <b>Delivery Details</b>
                </div>
                <br />
                <div>Delivery date: {deliveryDate}</div>
                <br />
                <div>Delivery time: {deliveryTime}</div>
                <br />
                <div>Delivery Address: {deliveryAddress}</div>
                <br />
                <div>Region: {region}</div>
                <hr />
                <div>
                  <b>Message Details</b>
                </div>
                <br />
                <div>To: {messageTo}</div>
                <br />
                <div>Message: {messageContent}</div>
                <br />
                <div>From: {messageFrom}</div>
                <hr />
                <div>
                  <b>Order Notes to us</b>
                </div>
                <br />
                <div>{orderNotes}</div>
              </Col>
            );
          }
        }

        customDiv = (
          <div style={{width: "100%",display: "flex", flexDirection:"column", alignItems: "center", justifyContent:"center"}}>
              <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal_class">
                <Modal.Header closeButton className={"order3_modal_header"}>
                  <Modal.Title>WARM REMINDER</Modal.Title>
                </Modal.Header>
                <Modal.Body className={"order3_modal_body"}>
                  <h2>You have not completed your order, please complete to finish the order process</h2>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={this.handleClose}>Close</Button>
                </Modal.Footer>
              </Modal>
            <div style={{ width: "80%", display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "flex-start", justifyContent:"space-around"}}>
              {orderedList}
              </div>
            <div className="OrderListDetail">
              <div className="OrderListContactDetail">
                <h4>
                  <b>Contact Detail</b>
                </h4>
                <br />
                <div>Display name: {contactDisplayName}</div>
                <br />
                {/*<div>Last name: {contactlastName}</div>*/}
                {/*<br />*/}
                <div>Email address: {contactPersonEmailAddress}</div>
                <br />
                <div>Phone: {contactPersonPhone}</div>
                <br />
                <br />
              </div>

              <Row className="show-grid">{col}</Row>
            </div>
            <DecisionButtons orderListContactDetail={orderListContactDetail} />
          </div>
        );
      } else {
        customDiv = (
          <div className="OrderListPanel">
            <div className="CartListCaption">
              <i className="fa fa-home" /> Return To Store
            </div>
            Your shopping cart is still empty.
          </div>
        );
      }
    }

    return <div>{customDiv}</div>;
  }
}

function mapStateToProps(state) {
  return {
    shoppingCartItems: state.shoppingCartItems,
    userToken: state.userToken
  };
}

export default connect(
  mapStateToProps,
  { fetchUserToken, fetchShoppingCartItems }
)(OrderListPanel);



// WEBPACK FOOTER //
// ./src/components/orderPage3/orderListPanel.js